import { useEffect, useState } from 'react';

const useScrollDirection = (): 'down' | 'up' | null => {
  const [scrollDirection, setScrollDirection] = useState(null);
  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? 'down' : 'up';

      if (direction !== scrollDirection) {
        setScrollDirection(direction);
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener('scroll', updateScrollDirection, {
      passive: true,
    });
    return () => {
      window.removeEventListener('scroll', updateScrollDirection, {
        passive: true,
      });
    };
  }, [scrollDirection]);
  return scrollDirection;
};

export default useScrollDirection;
